<div [ngClass]="{ 'cursor-progress': waiting, 'cursor-default': !waiting }">
  <form class="form-inline" (keyup.enter)="search()">
    <div class="form-group">
      <select class="selectpicker form-control" [(ngModel)]="searchType" name="searchType" [disabled]="disabled">
        @for (item of selectOptions; track item) {
          <option value="{{ item.value }}">{{ item.label }}</option>
        }
      </select>
    </div>

    @if (showSearchButton) {
      <button type="submit" class="btn btn-primary" (click)="search()" [disabled]="!searchButtonEnabled">Search</button>
    }
  </form>
</div>
